import(/* webpackMode: "eager" */ "/codebuild/output/src3457723357/src/rmh-platform/apps/rmh-patient/app/error.tsx");
